import _ from "lodash";
import React from "react";
import { FilterRender } from "react-table";

import useGlobalSettings from "src/core/shared/hooks/useGlobalSettings";
import { Select } from "src/library/components/Forms";

/**
 * @description Renders a select component to pick between lead time groups as offered by globalSettings.leadTimeGroups.
 * Displays options with leadTimeGroup.name and uses option values as leadTimeGroup.id.
 */
const LeadTimeGroupFilter: FilterRender = ({ onChange, filter }) => {
  const [ { globalSettings } ] = useGlobalSettings();

  return (
    <Select
      value={filter ? filter.value : ""}
      label=""
      as="select"
      name="status"
      unselectedOption={{
        text: "Please Select",
        value: ""
      }}
      handleChange={e => onChange(e.target.value)}
      options={_.map(globalSettings?.leadTimeGroups, status => ({
        text: status.name,
        value: status.id.toString(),
        checked: filter && filter.value === status.id
      }))}
    />
  );
};

export default LeadTimeGroupFilter;